import { timeParse } from 'd3-time-format'

import { Index, IndexDTO } from '../store/StateObjects'

const parseTime: (x: string) => Date = timeParse('%d/%m/%Y')

const transformData = (data: IndexDTO[] = []): Index[] => {
  return data.map((x) => ({
    ...x,
    week: typeof x.week === 'string' ? parseTime(x.week) : x.week,
  }))
}

export default transformData
